/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTutorialResponseAllOfData
 */
export interface GetTutorialResponseAllOfData {
    /**
     * チュートリアルの完了状態
     * @type {boolean}
     * @memberof GetTutorialResponseAllOfData
     */
    isCompleted: boolean;
}

export function GetTutorialResponseAllOfDataFromJSON(json: any): GetTutorialResponseAllOfData {
    return GetTutorialResponseAllOfDataFromJSONTyped(json, false);
}

export function GetTutorialResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTutorialResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isCompleted': json['is_completed'],
    };
}

export function GetTutorialResponseAllOfDataToJSON(value?: GetTutorialResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_completed': value.isCompleted,
    };
}

